import { makeStyles } from "@material-ui/core/styles";

export const useLinkStyles = makeStyles(({ typography }) => ({
  link: {
    fontWeight: typography.fontWeightMedium,
    textDecoration: "underline",
    transition: "250ms color ease-in-out",
  },
}));
